module.exports = __webpack_public_path__ + "assets/heart.a7517ea597f6992ba8b7facd3105bd9d1db8b82f98cc0b8343ed56fe25ad376d.png";